<div
  class="flex items-center justify-between border border-aux-gray-dark bg-aux-blue-arctic px-3 py-4"
>
  <p>
    Current Investigator Forecast Source:
    <span class="font-bold">
      {{ source }}:
      {{ amount | money }}
    </span>
  </p>
</div>
